/* ==============================================
   THEME.JS — Clone of Perfume — Clean Rebuild
   ============================================== */

/* --- Debounce Utility --- */
function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

/* --- Mobile Menu Toggle --- */
class MobileMenu {
  constructor() {
    this.menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    this.menuClose = document.querySelector('[data-mobile-menu-close]');
    this.menu = document.querySelector('[data-mobile-menu]');
    this.overlay = document.querySelector('[data-mobile-menu-overlay]');

    if (this.menuToggle && this.menu) {
      this.menuToggle.addEventListener('click', () => this.open());
      if (this.menuClose) this.menuClose.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    }
  }

  open() {
    this.menu.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.menu.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
  }
}

/* --- Cart Page AJAX Controller --- */
class CartPage {
  static init() {
    const cartSection = document.querySelector('#main-cart-items');
    if (!cartSection) return;

    /* Quantity change buttons (debounced) */
    cartSection.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        const key = qtyBtn.dataset.key;
        const action = qtyBtn.dataset.action;
        const container = qtyBtn.closest('[data-quantity-selector]');
        const input = container ? container.querySelector('[data-quantity-input]') : null;
        if (!input) return;
        let qty = parseInt(input.value) || 1;
        qty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        input.value = qty;
        CartPage.debouncedUpdate(key, qty, qtyBtn.closest('[data-cart-item]'));
      }

      /* Remove button */
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.dataset.key;
        CartPage.updateItem(key, 0, removeBtn.closest('[data-cart-item]'));
      }
    });

    /* Discount code apply */
    document.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('[data-apply-discount]');
      if (applyBtn) {
        const input = document.querySelector('[data-discount-input]');
        const feedback = document.querySelector('[data-discount-feedback]');
        if (input && input.value.trim()) {
          CartPage.applyDiscount(input.value.trim(), feedback);
        }
      }
    });

    /* Save cart note (auto-save on blur) */
    const noteTextarea = document.querySelector('[data-cart-note]');
    if (noteTextarea) {
      noteTextarea.addEventListener('change', () => {
        CartPage.saveNote(noteTextarea.value);
      });
    }
  }

  static debouncedUpdate = debounce((key, qty, itemEl) => {
    CartPage.updateItem(key, qty, itemEl);
  }, 400);

  static async updateItem(key, quantity, itemEl) {
    /* Show loading */
    if (itemEl) {
      const loader = itemEl.querySelector('[data-loading-overlay]');
      if (loader) loader.classList.add('is-active');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await response.json();

      /* Update cart count badge */
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-hidden', cart.item_count === 0);
      });

      /* Refresh the cart page */
      CartPage.refreshCartPage();

    } catch (err) {
      console.error('Cart page update error:', err);
      if (itemEl) {
        const loader = itemEl.querySelector('[data-loading-overlay]');
        if (loader) loader.classList.remove('is-active');
      }
    }
  }

  static async refreshCartPage() {
    const cartSection = document.querySelector('#main-cart-items');
    if (!cartSection) return;

    try {
      const res = await fetch(window.location.href);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      /* Replace cart items section */
      const newSection = doc.querySelector('#main-cart-items');
      if (newSection && cartSection) {
        cartSection.innerHTML = newSection.innerHTML;
        /* Re-init quantity selectors */
        cartSection.querySelectorAll('[data-quantity-selector]').forEach(el => new QuantitySelector(el));
        /* Re-init cart page events */
        CartPage.init();
      }

      /* Update cart summary */
      const newSummary = doc.querySelector('[data-cart-summary]');
      const currentSummary = document.querySelector('[data-cart-summary]');
      if (newSummary && currentSummary) {
        currentSummary.innerHTML = newSummary.innerHTML;
      }

      /* Update mobile sticky bar */
      const newSticky = doc.querySelector('[data-cart-sticky-bar]');
      const currentSticky = document.querySelector('[data-cart-sticky-bar]');
      if (newSticky && currentSticky) {
        currentSticky.innerHTML = newSticky.innerHTML;
      }

      /* Update cart count badges */
      const res2 = await fetch('/cart.json');
      const cartData = await res2.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cartData.item_count;
        el.classList.toggle('is-hidden', cartData.item_count === 0);
      });

    } catch (err) {
      console.error('Cart page refresh error:', err);
    }
  }

  static async saveNote(note) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
    } catch (err) {
      console.error('Note save error:', err);
    }
  }

  static async applyDiscount(code, feedbackEl) {
    try {
      if (feedbackEl) feedbackEl.innerHTML = '<small style="opacity:0.6">Applying...</small>';
      await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'include' });
      if (feedbackEl) feedbackEl.innerHTML = '<small style="color:green">✓ Discount applied! Refreshing...</small>';
      setTimeout(() => { window.location.reload(); }, 800);
    } catch (err) {
      if (feedbackEl) feedbackEl.innerHTML = '<small style="color:red">Failed to apply discount</small>';
    }
  }
}

/* --- Accordion / Collapsible Content --- */
class Accordion {
  constructor(container) {
    this.container = container;
    this.triggers = container.querySelectorAll('[data-accordion-trigger]');

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.toggle(trigger));
    });
  }

  toggle(trigger) {
    const content = trigger.nextElementSibling;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    trigger.setAttribute('aria-expanded', !isOpen);
    content.style.maxHeight = isOpen ? '0' : content.scrollHeight + 'px';
    content.classList.toggle('is-open', !isOpen);
  }
}

/* --- Quantity Selector --- */
class QuantitySelector {
  constructor(container) {
    this.input = container.querySelector('[data-quantity-input]');
    this.btnMinus = container.querySelector('[data-quantity-minus]');
    this.btnPlus = container.querySelector('[data-quantity-plus]');

    if (!this.input) return;

    this.btnMinus?.addEventListener('click', () => this.change(-1));
    this.btnPlus?.addEventListener('click', () => this.change(1));
  }

  change(delta) {
    const currentVal = parseInt(this.input.value) || 1;
    const min = parseInt(this.input.min) || 1;
    const max = parseInt(this.input.max) || 9999;
    const newVal = Math.min(Math.max(currentVal + delta, min), max);
    this.input.value = newVal;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

/* --- Sticky Header --- */
class StickyHeader {
  constructor() {
    this.header = document.querySelector('[data-sticky-header]');
    if (!this.header) return;

    this.headerOffset = this.header.offsetTop + this.header.offsetHeight;

    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.headerOffset) {
      this.header.classList.add('is-sticky');
    } else {
      this.header.classList.remove('is-sticky');
    }
  }
}

/* --- Product Form (Add to Cart — Instant Drawer) --- */
class ProductForm {
  constructor(form) {
    this.form = form;
    this.submitBtn = form.querySelector('[type="submit"]');
    this.originalHTML = this.submitBtn ? this.submitBtn.innerHTML : '';

    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.submitBtn || this.submitBtn.classList.contains('is-loading')) return;

    // INSTANT visual feedback
    this.submitBtn.disabled = true;
    this.setButtonState('loading');

    // Close quick buy modal IMMEDIATELY (before fetch)
    const openQuickBuyModal = document.querySelector('.quick-buy-modal.is-open');
    if (openQuickBuyModal) {
      openQuickBuyModal.classList.remove('is-open');
      openQuickBuyModal.setAttribute('aria-hidden', 'true');
    }

    // Fire off async cart add
    this.addToCart();
  }

  async addToCart() {
    // Cart module (assets/cart.js): queue, section re-render, opens the drawer
    if (window.CartModule) {
      try {
        await window.CartModule.addForm(this.form);
        this.setButtonState('success');
        setTimeout(() => {
          this.setButtonState('idle');
          this.submitBtn.disabled = false;
        }, 1200);
      } catch (error) {
        console.error('Cart error:', error.message);
        this.setButtonState('error');
        setTimeout(() => {
          this.setButtonState('idle');
          this.submitBtn.disabled = false;
        }, 2000);
      }
      return;
    }

    const formData = new FormData(this.form);
    let cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (!cartAddUrl.endsWith('.js')) cartAddUrl += '.js';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        this.setButtonState('success');

        // Refresh drawer — NO delay, server already has the data
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Also update cart count (parallel)
        this.updateCartCount();

        // Reset button
        setTimeout(() => {
          this.setButtonState('idle');
          this.submitBtn.disabled = false;
        }, 1200);
      } else {
        console.error('Cart error:', data.description || data.message);
        this.setButtonState('error');
        setTimeout(() => {
          this.setButtonState('idle');
          this.submitBtn.disabled = false;
        }, 2000);
      }
    } catch (error) {
      console.error('Add to cart failed:', error);
      this.setButtonState('error');
      setTimeout(() => {
        this.setButtonState('idle');
        this.submitBtn.disabled = false;
      }, 2000);
    }
  }

  setButtonState(state) {
    if (!this.submitBtn) return;

    this.submitBtn.classList.remove('is-loading', 'is-success', 'is-error');

    switch(state) {
      case 'loading':
        this.submitBtn.classList.add('is-loading');
        this.submitBtn.innerHTML = '<span class="btn-spinner"></span><span>ADDING...</span>';
        break;
      case 'success':
        this.submitBtn.classList.add('is-success');
        this.submitBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>ADDED!</span>';
        break;
      case 'error':
        this.submitBtn.classList.add('is-error');
        this.submitBtn.innerHTML = '<span>ERROR — TRY AGAIN</span>';
        break;
      default:
        this.submitBtn.innerHTML = this.originalHTML;
        break;
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-hidden', cart.item_count === 0);
      });
    } catch (e) { /* silent */ }
  }
}

/* --- Variant Picker with Section Rendering API --- */
class VariantPicker {
  constructor(container) {
    this.container = container;
    this.productData = JSON.parse(container.querySelector('[data-product-json]')?.textContent || '{}');
    this.options = container.querySelectorAll('[data-variant-option]');
    this.priceEl = container.querySelector('[data-product-price]');
    this.comparePriceEl = container.querySelector('[data-product-compare-price]');
    // IMPORTANT: target the ADD-TO-CART form specifically.
    // The page also contains an installment/payment-terms form that has its own
    // input[name="id"] which appears FIRST in the DOM. Using a plain
    // container.querySelector('input[name="id"]') would update that input instead
    // of the cart form, so the wrong variant gets added to the cart.
    this.productFormEl = container.querySelector('form[data-product-form]') ||
                         container.querySelector('form[action*="/cart/add"]');
    const formScope = this.productFormEl || container;
    this.variantIdInput = formScope.querySelector('input[name="id"]') ||
                          container.querySelector('input[name="id"]');
    this.submitBtn = formScope.querySelector('[type="submit"]') ||
                     container.querySelector('[type="submit"]');
    this.sectionId = container.closest('[data-section-id]')?.dataset.sectionId;
    this.infoEl = container.querySelector('.main-product__info') || container;

    // Debounced section fetch to avoid rapid calls
    this._debouncedSectionFetch = debounce((variantId) => this.fetchSection(variantId), 250);

    // Remember the INITIAL (main) variant — the one selected on load.
    // When the user picks a different variant we hide the bundle offers,
    // and restore them when they switch back to the main variant.
    this.initialVariantId = this.variantIdInput
      ? parseInt(this.variantIdInput.value, 10)
      : (this.productData.selected_or_first_available_variant_id ||
         (this.productData.variants && this.productData.variants[0] && this.productData.variants[0].id));

    this.options.forEach(option => {
      option.addEventListener('change', () => this.onOptionChange());
    });


    // Initialize slider on load
    this.initSlider();
  }

  onOptionChange() {
    const selectedOptions = [];
    this.container.querySelectorAll('[data-variant-option]').forEach(el => {
      if (el.checked || el.selected || (el.type !== 'radio' && el.type !== 'checkbox' && el.value)) {
        selectedOptions.push(el.value);
      }
    });

    const variant = this.productData.variants?.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (!variant) return;

    // INSTANT price & button update (no waiting for fetch)
    this.variantIdInput.value = variant.id;
    this.updatePrice(variant);
    this.updateButton(variant);

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Navigate the existing gallery to the variant's featured image.
    // We do NOT re-fetch / re-render the gallery HTML, so that variants
    // WITHOUT their own image simply keep showing the current images
    // instead of wiping the gallery (which used to make images disappear
    // and never come back).
    this.updateVariantMedia(variant);

    // Show the Bundle & Save offers ONLY for the main (initial) variant.
    // When a different variant is selected, hide the bundle functionality;
    // restore it when switching back to the main variant.
    this.toggleBundleOffers(variant.id === this.initialVariantId);
  }

  toggleBundleOffers(show) {
    // Look within the section first (handles Quick Buy modal scope), fall back to document.
    const scope = this.container.closest('.main-product') || document;
    const bundleEls = scope.querySelectorAll('.bundle-offers, kaching-bundle, .kaching-bundles');
    bundleEls.forEach(el => {
      el.style.display = show ? '' : 'none';
    });
  }


  updateVariantMedia(variant) {
    const track = this.container.querySelector('[data-slider-track]');
    if (!track) return;
    if (typeof this._goToSlide !== 'function') return;

    const mediaId = variant && variant.featured_media && variant.featured_media.id;

    // If the variant has a dedicated featured image, scroll to it.
    if (mediaId) {
      const targetSlide = track.querySelector(`[data-media-id="${mediaId}"]`);
      if (targetSlide) {
        const index = parseInt(targetSlide.dataset.slideIndex, 10);
        if (!isNaN(index)) {
          this._goToSlide(index);
          return;
        }
      }
    }

    // No dedicated image for this variant (e.g. switching back to the main
    // variant which has no explicit media assignment) — scroll back to the
    // first slide so the gallery returns to its default image instead of
    // staying stuck on the previous variant's picture.
    this._goToSlide(0);
  }



  updatePrice(variant) {
    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(variant.price);
    }
    if (this.comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
        this.comparePriceEl.style.display = '';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }

    // Update sale badge with discount percentage
    const saleBadge = this.container.querySelector('[data-sale-badge]');
    if (saleBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        // Preserve the badge markup (the "save dot" span + "Save N%" label).
        // Using textContent here would strip the dot and the word "Save",
        // leaving just "N%". Update only the dot's text sibling instead.
        const dot = saleBadge.querySelector('.mp-price__save-dot');
        if (dot) {
          // Rebuild: keep the dot element, set the label text after it.
          saleBadge.innerHTML = '';
          saleBadge.appendChild(dot);
          saleBadge.appendChild(document.createTextNode(' Save ' + pct + '%'));
        } else {
          saleBadge.textContent = 'Save ' + pct + '%';
        }
        saleBadge.style.display = '';
      } else {
        saleBadge.style.display = 'none';
      }
    }


    // Update price per ml
    const perMlEl = this.container.querySelector('[data-price-per-ml]');
    if (perMlEl) {
      const ml = this.getVariantMl(variant);
      if (ml > 0) {
        const perMlCents = variant.price / ml;
        perMlEl.textContent = this.formatMoney(Math.round(perMlCents)) + '/ml';
        perMlEl.style.display = '';
      } else {
        perMlEl.style.display = 'none';
      }
    }
  }

  getVariantMl(variant) {
    const options = this.productData.options;
    if (!options) return 0;
    let sizeIndex = -1;
    for (let i = 0; i < options.length; i++) {
      if (options[i].toLowerCase() === 'size') {
        sizeIndex = i;
        break;
      }
    }
    if (sizeIndex === -1) return 0;
    const sizeVal = variant.options[sizeIndex];
    if (!sizeVal) return 0;
    const match = sizeVal.match(/(\d+)\s*ML/i);
    return match ? parseInt(match[1]) : 0;
  }

  updateButton(variant) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = !variant.available;
    const addText = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    const soldText = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    this.submitBtn.textContent = variant.available ? addText : soldText;
  }

  showLoading() {
    // Add a subtle loading overlay to the product info
    if (!this.loadingOverlay) {
      this.loadingOverlay = document.createElement('div');
      this.loadingOverlay.className = 'variant-loading-overlay';
      this.loadingOverlay.innerHTML = '<span class="btn-spinner"></span>';
      this.infoEl.style.position = 'relative';
      this.infoEl.appendChild(this.loadingOverlay);
    }
    this.loadingOverlay.classList.add('is-active');
  }

  hideLoading() {
    if (this.loadingOverlay) {
      this.loadingOverlay.classList.remove('is-active');
    }
  }

  async fetchSection(variantId) {
    try {
      // Use the PRODUCT's own URL (from product JSON), NOT window.location.pathname.
      // In the Quick Buy modal the page URL is the collection/whatever page the
      // modal was opened from — fetching that would return the wrong section and
      // wipe out the media gallery (image disappears and never comes back).
      let productPath = this.productData && this.productData.url
        ? this.productData.url.split('?')[0]
        : window.location.pathname;
      const url = `${productPath}?variant=${variantId}&section_id=${this.sectionId}`;
      const response = await fetch(url);

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update media gallery
      const newMediaWrapper = doc.querySelector('.main-product__media-wrapper');
      const currentMediaWrapper = this.container.querySelector('.main-product__media-wrapper');
      if (newMediaWrapper && currentMediaWrapper) {
        currentMediaWrapper.innerHTML = newMediaWrapper.innerHTML;
        this.initSlider();
      }

      this.hideLoading();
    } catch (error) {
      console.error('Section fetch error:', error);
      this.hideLoading();
    }
  }

  initThumbnails() {
    // Legacy — redirect to initSlider
    this.initSlider();
  }

  initSlider() {
    const slider = this.container.querySelector('[data-media-slider]');
    const track = this.container.querySelector('[data-slider-track]');
    if (!slider || !track) return;

    const slides = track.querySelectorAll('[data-slide-index]');
    const thumbs = this.container.querySelectorAll('[data-thumb-index]');
    const dots = this.container.querySelectorAll('[data-dot-index]');
    const prevBtn = this.container.querySelector('[data-slider-prev]');
    const nextBtn = this.container.querySelector('[data-slider-next]');
    const counterCurrent = this.container.querySelector('[data-counter-current]');
    const totalSlides = slides.length;

    if (totalSlides <= 0) return;

    // Keep a reference to the slides for variant-media navigation
    this._slides = slides;


    let currentIndex = 0;

    // --- Go to slide ---
    const goToSlide = (index, smooth = true) => {
      if (index < 0) index = 0;
      if (index >= totalSlides) index = totalSlides - 1;
      currentIndex = index;

      // Move track
      if (!smooth) track.style.transition = 'none';
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      if (!smooth) {
        // force reflow then restore transition
        track.offsetHeight;
        track.style.transition = '';
      }

      // Update active states
      slides.forEach((s, i) => s.classList.toggle('is-active', i === currentIndex));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === currentIndex));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === currentIndex));

      // Update counter
      if (counterCurrent) counterCurrent.textContent = currentIndex + 1;

      // Scroll active thumbnail into view
      const activeThumb = thumbs[currentIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    };

    // --- Thumbnail clicks ---
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goToSlide(parseInt(thumb.dataset.thumbIndex));
      });
    });

    // --- Dot clicks ---
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goToSlide(parseInt(dot.dataset.dotIndex));
      });
    });

    // --- Arrow clicks ---
    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

    // --- Keyboard navigation ---
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(currentIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(currentIndex + 1); }
    });

    // --- Touch / Swipe support ---
    let touchStartX = 0;
    let touchStartY = 0;
    let touchDeltaX = 0;
    let isSwiping = false;
    let isHorizontalSwipe = null;
    const swipeThreshold = 40;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      isSwiping = true;
      isHorizontalSwipe = null;
      track.classList.add('is-swiping');
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (!isSwiping) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;

      // Determine swipe direction on first significant move
      if (isHorizontalSwipe === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        isHorizontalSwipe = Math.abs(dx) > Math.abs(dy);
      }

      if (!isHorizontalSwipe) return;

      e.preventDefault();
      touchDeltaX = dx;

      // Live drag feedback
      const offset = -(currentIndex * 100) + (touchDeltaX / slider.offsetWidth) * 100;
      track.style.transform = `translateX(${offset}%)`;
    }, { passive: false });

    slider.addEventListener('touchend', () => {
      if (!isSwiping) return;
      isSwiping = false;
      track.classList.remove('is-swiping');

      if (isHorizontalSwipe && Math.abs(touchDeltaX) > swipeThreshold) {
        if (touchDeltaX < 0 && currentIndex < totalSlides - 1) {
          goToSlide(currentIndex + 1);
        } else if (touchDeltaX > 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1);
        } else {
          goToSlide(currentIndex); // snap back
        }
      } else {
        goToSlide(currentIndex); // snap back
      }
    }, { passive: true });

    slider.addEventListener('touchcancel', () => {
      isSwiping = false;
      track.classList.remove('is-swiping');
      goToSlide(currentIndex);
    }, { passive: true });

    // Expose navigation so the variant picker can jump to a variant's image
    this._goToSlide = goToSlide;

    // Init first slide
    goToSlide(0, false);
  }

  formatMoney(cents) {

    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: (typeof Shopify !== 'undefined' && Shopify.currency?.active) || 'USD'
    });
  }
}

/* --- Quick Buy Modal --- */
class QuickBuyModal {
  constructor() {
    this.activeModal = null;
    this.cache = {};

    // Relocate all quick-buy modals to document.body to avoid
    // grid/flex container issues (overflow clipping, stacking context, etc.)
    this.relocateModals();

    // Watch for dynamically added modals (e.g. product-recommendations loaded via AJAX)
    this.observeDynamicModals();

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-buy-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const productId = trigger.dataset.productId;
        const productUrl = trigger.dataset.productUrl;
        const mode = trigger.dataset.quickBuyMode || 'full'; // 'compact' = no images, 'full' = with images
        if (productId && productUrl) {
          // Ensure all modals are relocated to <body> BEFORE opening.
          // Safety net for cases when product-recommendations (or any other AJAX section)
          // added new modals and the MutationObserver has not fired yet.
          this.relocateModals();
          this.open(productId, productUrl, mode);
        }
      }

      const closeBtn = e.target.closest('[data-quick-buy-close]');
      if (closeBtn) {
        this.close();
      }
    }, true); // capture phase — fires before any <a>/overlay navigation

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeModal) {
        this.close();
      }
    });
  }

  async open(productId, productUrl, mode = 'full') {
    // Close any previously open modal first
    if (this.activeModal) {
      this.closeImmediate();
    }

    const modal = document.querySelector(`[data-quick-buy-modal="${productId}"]`);
    if (!modal) return;

    this.activeModal = modal;
    this.currentMode = mode;
    const loading = modal.querySelector('.quick-buy-modal__loading');
    const contentEl = modal.querySelector('[data-quick-buy-product-content]');
    const modalContent = modal.querySelector('.quick-buy-modal__content');

    // Apply mode class
    if (modalContent) {
      modalContent.classList.remove('quick-buy-modal__content--compact', 'quick-buy-modal__content--full');
      modalContent.classList.add(mode === 'compact' ? 'quick-buy-modal__content--compact' : 'quick-buy-modal__content--full');
      // Reset scroll position to top
      modalContent.scrollTop = 0;
    }

    // Show modal
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    // If we have cached content, render immediately
    if (this.cache[productId]) {
      if (loading) loading.style.display = 'none';
      this.renderContent(contentEl, loading, this.cache[productId], mode);
      return;
    }

    // Not cached — show loading spinner
    if (loading) {
      loading.style.display = 'flex';
    }
    if (contentEl) {
      contentEl.style.opacity = '0';
      contentEl.innerHTML = '';
    }

    try {
      const sectionUrl = `${productUrl}?section_id=main-product`;
      const response = await fetch(sectionUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();

      this.cache[productId] = html;
      this.renderContent(contentEl, loading, html, mode);
    } catch (error) {
      console.error('Quick Buy fetch error:', error);
      if (contentEl) {
        contentEl.innerHTML = `
          <div style="padding: 3rem; text-align: center;">
            <p>Could not load product details.</p>
            <a href="${productUrl}" class="btn btn--primary" style="margin-top: 1rem;">View Product</a>
          </div>`;
        contentEl.style.opacity = '1';
      }
      if (loading) loading.style.display = 'none';
    }
  }

  renderContent(contentEl, loading, html, mode = 'full') {
    if (!contentEl) {
      if (loading) loading.style.display = 'none';
      return;
    }

    // Parse the HTML and extract ONLY the main-product section + its styles
    // (the fetch may return full page with header/footer when section_id doesn't match template context)
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    let mainProductSection = doc.querySelector('.main-product') || doc.querySelector('[data-section-id]') || doc.querySelector('section');

    // === Clean up IN-MEMORY (parsed doc) BEFORE inserting into live DOM ===
    // This prevents layout thrashing / visible jerking from sequential .remove() calls
    const cleanupTarget = mainProductSection || doc.body;

    if (!mainProductSection) {
      // Fallback: strip obvious layout elements from the full doc
      doc.querySelectorAll('header, footer, nav, .shopify-section-header, .shopify-section-footer, .announcement-bar, .header, [data-sticky-header], .site-header').forEach(el => el.remove());
    }

    // Deduplicate ratings — keep only the first rating wrapper
    const ratingWrappers = cleanupTarget.querySelectorAll('.main-product__rating-wrapper');
    if (ratingWrappers.length > 1) {
      for (let i = 1; i < ratingWrappers.length; i++) {
        ratingWrappers[i].remove();
      }
    }

    // Remove non-essential blocks
    cleanupTarget.querySelectorAll('.main-product__faq').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.main-product__badges-grid').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.main-product__text').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.main-product__meta').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.main-product__size-guide').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('kaching-bundle').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.bundle-offers, .bundle-popup').forEach(el => el.remove());
    cleanupTarget.querySelectorAll('.cvd__wrapper').forEach(el => el.remove());

    // Remove Essential Estimated Delivery app block (shopify-block wrapper + custom element)
    cleanupTarget.querySelectorAll(
      'essential-estimated-delivery-app-block,' +
      '[id*="essential_estimated"],' +
      '.shopify-block[id*="essential_estimated"],' +
      '[data-block-handle*="essential-estimated"]'
    ).forEach(el => {
      // Prefer to remove the shopify-block wrapper (keeps layout clean)
      const wrapper = el.closest && el.closest('.shopify-block');
      (wrapper || el).remove();
    });

    // Keep only Description collapsible, remove others (Instructions, Scent Profile, etc.)
    cleanupTarget.querySelectorAll('.main-product__collapsible').forEach(el => {
      const summary = el.querySelector('summary');
      if (summary) {
        const text = summary.textContent.trim().toLowerCase();
        if (text === 'description') return; // keep Description
      }
      el.remove(); // remove all others
    });

    // In compact mode, additionally strip gallery
    if (mode === 'compact') {
      cleanupTarget.querySelectorAll('.main-product__media-wrapper').forEach(el => el.remove());
    }

    // === Now insert the CLEAN content into live DOM in one shot ===
    if (mainProductSection) {
      let stylesHTML = '';
      doc.querySelectorAll('style').forEach(styleEl => {
        stylesHTML += styleEl.outerHTML;
      });
      contentEl.innerHTML = stylesHTML + mainProductSection.outerHTML;
    } else {
      contentEl.innerHTML = doc.body.innerHTML;
    }

    // In compact mode, force single-column block layout (needs live DOM for style)
    if (mode === 'compact') {
      contentEl.querySelectorAll('.main-product__grid').forEach(el => {
        el.style.display = 'block';
        // Padding is controlled via CSS (.quick-buy-modal__content--compact .main-product__grid)
        // so it can adapt responsively on mobile — do NOT set inline padding here.
        el.style.removeProperty('padding');
      });
    }

    // Auto-shrink "Inspired by" text if it wraps — BEFORE showing content to prevent visible jump
    // Content is in DOM with opacity:0, so we can measure layout
    contentEl.querySelectorAll('.main-product__inspired-text').forEach(el => {
      el.classList.remove('inspired-text--shrink');
      // Measure single-line height by temporarily forcing nowrap
      el.style.whiteSpace = 'nowrap';
      const singleH = el.offsetHeight;
      el.style.whiteSpace = '';
      const actualH = el.offsetHeight;
      if (actualH > singleH + 4) {
        el.classList.add('inspired-text--shrink');
      }
    });

    // Hide loading, show content — IMMEDIATELY, no requestAnimationFrame
    if (loading) loading.style.display = 'none';
    contentEl.style.opacity = '1';

    // Reset scroll to top so title/price/ATC are visible first
    const modalContent = contentEl.closest('.quick-buy-modal__content');
    if (modalContent) modalContent.scrollTop = 0;
    const infoCol = contentEl.querySelector('.main-product__info');
    if (infoCol) infoCol.scrollTop = 0;

    // Initialize interactive elements (with error protection)
    try {
      contentEl.querySelectorAll('form[data-product-form]').forEach(form => {
        try { new ProductForm(form); } catch(e) { console.warn('ProductForm init error:', e); }
      });
      contentEl.querySelectorAll('[data-variant-picker]').forEach(el => {
        try { new VariantPicker(el); } catch(e) { console.warn('VariantPicker init error:', e); }
      });
      if (mode === 'full') {
        contentEl.querySelectorAll('[data-media-slider]').forEach(slider => {
          if (slider.closest('[data-variant-picker]') && slider.closest('[data-variant-picker]').querySelector('[data-variant-option]')) return;
          const container = slider.closest('.main-product__grid') || slider.closest('.main-product') || slider.parentElement;
          if (container) {
            try { new VariantPicker(container); } catch(e) { console.warn('Slider init error:', e); }
          }
        });
      }
      contentEl.querySelectorAll('[data-quantity-selector]').forEach(el => {
        try { new QuantitySelector(el); } catch(e) { /* silent */ }
      });

      // Re-initialize Judge.me badges inside modal with retry
      // (Judge.me needs DOM to be visible and may require multiple attempts)
      this.initJudgeMeBadges(contentEl);

    } catch(e) {
      console.warn('Quick Buy init error:', e);
    }
  }

  initJudgeMeBadges(contentEl) {
    // Strategy: 1) Judge.me JS re-init, 2) batchRenderBadges, 3) copy from product card

    const tryJudgeMeInit = () => {
      try {
        if (typeof jdgm !== 'undefined') {
          // Method from old theme — batchRenderBadges for dynamic content
          if (jdgm.batchRenderBadges) {
            const badges = contentEl.querySelectorAll('.jdgm-preview-badge[data-id]');
            badges.forEach(badge => {
              const handle = badge.getAttribute('data-handle');
              if (handle) {
                jdgm.batchRenderBadges([{ productHandle: handle, el: badge }]);
              }
            });
          }
          if (jdgm.customizeBadges) jdgm.customizeBadges();
          if (jdgm.initBadges) jdgm.initBadges();
        }
      } catch(e) { /* silent */ }
    };

    // Step 1: Try immediately
    tryJudgeMeInit();

    // Step 2: After delay, check + copy fallback from product cards on page
    setTimeout(() => {
      const modalBadges = contentEl.querySelectorAll('.jdgm-preview-badge[data-id]');
      modalBadges.forEach(modalBadge => {
        const productId = modalBadge.getAttribute('data-id');
        if (!productId) return;

        // Check if badge already has review count
        const hasCount = modalBadge.querySelector('.jdgm-prev-badge__text') ||
                        modalBadge.textContent.match(/\d+\s*(review|Reviews)/i);
        if (hasCount) return;

        // Copy from any matching badge on the page (product cards already populated by Judge.me)
        const pageBadges = document.querySelectorAll(`.jdgm-preview-badge[data-id="${productId}"]`);
        for (const pageBadge of pageBadges) {
          if (pageBadge === modalBadge) continue;
          if (pageBadge.innerHTML.trim() && pageBadge.textContent.match(/\d+\s*(review|Reviews)/i)) {
            modalBadge.innerHTML = pageBadge.innerHTML;
            modalBadge.className = pageBadge.className;
            return;
          }
        }
      });

      // Retry Judge.me init
      tryJudgeMeInit();
    }, 800);

    // Step 3: Final retry
    setTimeout(() => tryJudgeMeInit(), 2000);
  }

  relocateModals() {
    // Move all quick-buy modals to body and deduplicate
    // (same product might appear in multiple sections → multiple modals with same ID)
    const seen = new Set();
    document.querySelectorAll('.quick-buy-modal').forEach(modal => {
      const productId = modal.dataset.quickBuyModal;
      if (seen.has(productId)) {
        // Duplicate — remove it
        modal.remove();
        return;
      }
      seen.add(productId);
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  observeDynamicModals() {
    // Watch for dynamically added quick-buy modals (e.g. product-recommendations AJAX)
    const observer = new MutationObserver((mutations) => {
      let found = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          // Check if the node itself is a modal
          if (node.classList && node.classList.contains('quick-buy-modal')) {
            found = true;
            break;
          }
          // Check if node contains modals
          if (node.querySelectorAll && node.querySelectorAll('.quick-buy-modal').length > 0) {
            found = true;
            break;
          }
        }
        if (found) break;
      }
      if (found) {
        // Small delay to let DOM settle, then relocate
        requestAnimationFrame(() => this.relocateModals());
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  closeImmediate() {
    if (!this.activeModal) return;
    this.activeModal.classList.remove('is-open');
    this.activeModal.setAttribute('aria-hidden', 'true');
    this.activeModal = null;
  }

  close() {
    if (!this.activeModal) return;

    this.activeModal.classList.remove('is-open');
    this.activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    this.activeModal = null;
  }
}

/* --- Search Overlay Modal --- */
class SearchOverlayModal {
  constructor() {
    this.overlay = document.getElementById('SearchOverlayModal');
    if (!this.overlay) return;

    this.input = this.overlay.querySelector('#SearchOverlayInput');
    this.predictiveContainer = this.overlay.querySelector('[data-search-predictive]');
    this.predictiveResults = this.overlay.querySelector('[data-search-predictive-results]');
    this.predictiveLoading = this.overlay.querySelector('.search-overlay__predictive-loading');
    this.featuredSection = this.overlay.querySelector('[data-search-featured]');
    this.openButtons = document.querySelectorAll('[data-search-overlay-open]');
    this.closeButtons = this.overlay.querySelectorAll('[data-search-overlay-close]');

    this.isOpen = false;
    this.searchTimeout = null;

    this.bindEvents();
  }

  bindEvents() {
    // Open buttons
    this.openButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close buttons (X and backdrop)
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Predictive search on input
    if (this.input && this.predictiveContainer && window.routes && window.routes.predictive_search_url) {
      this.input.addEventListener('input', debounce(() => {
        this.onInputChange();
      }, 300));
    }
  }

  open() {
    this.isOpen = true;
    this.overlay.classList.add('is-open');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    // Focus on input after animation
    setTimeout(() => {
      if (this.input) this.input.focus();
    }, 150);
  }

  close() {
    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    // Clear predictive results
    if (this.predictiveContainer) {
      this.predictiveContainer.style.display = 'none';
    }
    if (this.predictiveResults) {
      this.predictiveResults.innerHTML = '';
    }
    // Show featured again
    if (this.featuredSection) {
      this.featuredSection.style.display = '';
    }
  }

  onInputChange() {
    const query = this.input.value.trim();

    if (query.length < 2) {
      // Hide predictive, show featured
      if (this.predictiveContainer) this.predictiveContainer.style.display = 'none';
      if (this.predictiveResults) this.predictiveResults.innerHTML = '';
      if (this.featuredSection) this.featuredSection.style.display = '';
      return;
    }

    // Show predictive area, hide featured
    if (this.predictiveContainer) this.predictiveContainer.style.display = 'block';
    if (this.predictiveLoading) this.predictiveLoading.style.display = 'flex';
    if (this.featuredSection) this.featuredSection.style.display = 'none';

    this.fetchPredictiveResults(query);
  }

  fetchPredictiveResults(query) {
    const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,query&resources[limit]=6&section_id=predictive-search`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Search failed');
        return response.text();
      })
      .then(html => {
        if (this.predictiveLoading) this.predictiveLoading.style.display = 'none';

        // Parse the section-rendered HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find the predictive-search-results container
        const results = doc.getElementById('predictive-search-results');

        if (results && results.innerHTML.trim()) {
          this.predictiveResults.innerHTML = results.outerHTML;
        } else {
          // Fallback: try to insert full body
          const body = doc.querySelector('body');
          if (body && body.innerHTML.trim()) {
            this.predictiveResults.innerHTML = body.innerHTML;
          } else {
            this.predictiveResults.innerHTML = `<div class="predictive-search__no-results"><p>No results found for "${query}"</p></div>`;
          }
        }
      })
      .catch(() => {
        if (this.predictiveLoading) this.predictiveLoading.style.display = 'none';
        this.predictiveResults.innerHTML = `<div class="predictive-search__no-results"><p>Search unavailable</p></div>`;
      });
  }
}

/* --- Page Ready: Reveal page smoothly after all critical JS is initialized --- */
function revealPage() {
  // Use rAF to ensure styles are computed before revealing
  requestAnimationFrame(() => {
  document.body.classList.add('page-ready');

  /* ── Accessibility: kaching-bundles product image buttons ── */
  function fixKachingAccessibility() {
    document.querySelectorAll('.kaching-bundles__collection-product__choose-product-image[role="button"]:not([aria-label])').forEach(function(el) {
      var title = '';
      var parent = el.closest('.kaching-bundles__collection-product');
      if (parent) {
        var titleEl = parent.querySelector('.kaching-bundles__collection-product__title, .kaching-bundles__collection-product__name');
        if (titleEl) title = titleEl.textContent.trim();
      }
      el.setAttribute('aria-label', title ? 'Choose product: ' + title : 'Choose product');
    });
    /* Fix video poster images missing alt */
    document.querySelectorAll('video > img:not([alt])').forEach(function(img) {
      img.setAttribute('alt', 'Video preview');
    });
  }
  fixKachingAccessibility();
  var kachingObserver = new MutationObserver(function() { fixKachingAccessibility(); });
  kachingObserver.observe(document.body, { childList: true, subtree: true });
  });
}

/* --- Initialize on DOMContentLoaded --- */
document.addEventListener('DOMContentLoaded', () => {
  // Critical above-the-fold initializations (sync, fast)
  new MobileMenu();
  new StickyHeader();

  // Product forms & variant pickers (may be above fold on product pages)
  document.querySelectorAll('form[data-product-form]').forEach(form => new ProductForm(form));
  document.querySelectorAll('[data-variant-picker]').forEach(el => new VariantPicker(el));

  // Standalone product media slider init (for pages without variant picker)
  document.querySelectorAll('[data-media-slider]').forEach(slider => {
    if (slider.closest('[data-variant-picker]') && slider.closest('[data-variant-picker]').querySelector('[data-variant-option]')) return;
    const container = slider.closest('.main-product') || slider.closest('.main-product__grid') || slider.parentElement;
    if (!container) return;
    new VariantPicker(container);
  });

  // Quick Buy Modal — must be ready BEFORE user can click any product card
  // (was previously deferred, causing missed first-taps on mobile)
  new QuickBuyModal();

  // ★ REVEAL PAGE — all critical components initialized, show the page
  revealPage();

  // Cart page AJAX controller
  CartPage.init();

  // Deferred initializations (below fold / interactive-only, can run after reveal)
  requestIdleCallback(() => {
    document.querySelectorAll('[data-accordion]').forEach(el => new Accordion(el));
    document.querySelectorAll('[data-quantity-selector]').forEach(el => new QuantitySelector(el));
    new SearchOverlayModal();
  }, { timeout: 200 });
});

/* --- Fallback: ensure page is always revealed even if JS errors occur --- */
window.addEventListener('load', () => {
  if (!document.body.classList.contains('page-ready')) {
    revealPage();
  }
});

/* ==============================================
   KACHING BUNDLE ENHANCER
   Injects rating, review count & "inspired by" into
   Kaching bundle bars and Choose-product modal items.
   Uses Judge.me batchRenderBadges with product handle.
   ============================================== */
(function() {
  const bundleObserver = new MutationObserver(function() {
    const titles = document.querySelectorAll(
      '.kaching-bundles__collection-product__title, .kaching-bundles__choose-product__product-title'
    );
    if (!titles.length) return;

    titles.forEach(async function(titleEl) {
      /* Skip if already processed */
      if (titleEl.dataset.kbProcessed) return;
      titleEl.dataset.kbProcessed = 'true';

      const productTitle = titleEl.textContent.trim();
      if (!productTitle) return;

      try {
        const res = await fetch(
          '/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product&resources[limit]=3'
        );
        if (!res.ok) return;
        const data = await res.json();

        /* Find exact match by title */
        const products = data.resources?.results?.products || [];
        let product = null;
        const normTitle = productTitle.toLowerCase().trim();
        for (var i = 0; i < products.length; i++) {
          if (products[i].title.toLowerCase().trim() === normTitle) {
            product = products[i];
            break;
          }
        }
        if (!product && products.length) product = products[0];
        if (!product) return;

        /* Determine insertion context */
        var isBarProduct = !!titleEl.closest('.kaching-bundles__collection-product');
        var isModalProduct = !!titleEl.closest('.kaching-bundles__choose-product__product');

        /* Find the right insertion point */
        var insertTarget;
        if (isBarProduct) {
          /* Bar: title is inside .kaching-bundles__collection-product__link wrapper */
          var linkWrapper = titleEl.closest('.kaching-bundles__collection-product__link');
          insertTarget = linkWrapper || titleEl;
        } else if (isModalProduct) {
          /* Modal: insert after price container or after title link */
          var contentEl = titleEl.closest('.kaching-bundles__choose-product__product-content');
          if (contentEl) {
            var priceContainer = contentEl.querySelector('.kaching-bundles__choose-product__product-price-container');
            insertTarget = priceContainer || titleEl.closest('.kaching-bundles__choose-product__product-link') || titleEl;
          } else {
            insertTarget = titleEl;
          }
        } else {
          insertTarget = titleEl;
        }

        /* Check if meta already injected after this target */
        if (insertTarget.nextElementSibling && insertTarget.nextElementSibling.classList.contains('kb-meta')) return;

        /* Build and insert meta container */
        var metaDiv = document.createElement('div');
        metaDiv.className = 'kb-meta';

        /* 1. Rating badge via Judge.me batchRenderBadges */
        if (product.handle) {
          var ratingDiv = document.createElement('div');
          ratingDiv.className = 'kb-meta__rating';
          var badgeDiv = document.createElement('div');
          badgeDiv.className = 'jdgm-prev-badge';
          badgeDiv.setAttribute('data-handle', product.handle);
          ratingDiv.appendChild(badgeDiv);
          metaDiv.appendChild(ratingDiv);

          /* Watch for Judge.me populating the badge to clean up text */
          var textObserver = new MutationObserver(function() {
            var textSpan = badgeDiv.querySelector('.jdgm-prev-badge__text');
            if (textSpan) {
              var txt = textSpan.textContent;
              /* Hide entirely if 0 reviews */
              if (txt.match(/^0\s/) || txt === 'No reviews') {
                ratingDiv.style.display = 'none';
              }
            }
          });
          textObserver.observe(badgeDiv, { childList: true, subtree: true, characterData: true });

          /* Trigger Judge.me badge render */
          setTimeout(function() {
            if (window.jdgm && window.jdgm.batchRenderBadges) {
              window.jdgm.batchRenderBadges([{
                productHandle: product.handle,
                badgePlaceholder: badgeDiv
              }]);
            }
          }, 100);
        }

        /* 2. Product type (inspired by) */
        if (product.type) {
          var typeSpan = document.createElement('span');
          typeSpan.className = 'kb-meta__type';
          if (product.type && product.type.indexOf('Inspired by ') === 0) {
            typeSpan.innerHTML = '<strong class="inspired-by-label">Inspired by</strong><br>' + product.type.replace('Inspired by ', '');
          } else {
            typeSpan.textContent = product.type;
          }
          metaDiv.appendChild(typeSpan);
        }

        /* Insert after the target */
        insertTarget.insertAdjacentElement('afterend', metaDiv);

      } catch(e) { /* silent */ }
    });
  });

  /* Start observing once DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bundleObserver.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    bundleObserver.observe(document.body, { childList: true, subtree: true });
  }
})();

/* --- requestIdleCallback polyfill for Safari --- */
if (typeof requestIdleCallback === 'undefined') {
  window.requestIdleCallback = function(cb, opts) {
    const start = Date.now();
    return setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
      });
    }, opts && opts.timeout ? Math.min(opts.timeout, 1) : 1);
  };
}
